<template>
  <section>
    <b-card class="mb-1 sticky-top" style="height: 58px; font-family: NanumBarunGothic; padding: 1.0rem 1.5rem;" no-body> 
      <b-row>
        <b-col xl="8" md="8" sm="8">
          <b-row class="d-flex align-items-center justify-content-start">
            <span class="bg-primary round text-white ml-2" style="width: 80px; font-size: 16px; font-weight: 400; margin-right: 5px; text-align: center;">조건</span>
            <vue-select
              class="criteria mr-5"
              label="title"
              :options="criteria"
              :clearable="false"
              v-model="selectedCriteria"
              placeholder="구분 기준"
              style="height: 32px; width: 180px; text-align: center; font-size: 12px; font-weight: 600; margin-left: 5px;"
            >
            </vue-select>
            <v-divider
              thickness="10"
              class="border-opacity-100"
              style="border-width: 1.2px; margin-top: 3px; margin-bottom: 1px; border-color: #d8d6de;"
              vertical
            />
            <vue-select
              class="major-class ml-5"
              label="title"            
              :options="majorClassList"
              :clearable="true"
              v-model="selectedMajorClass"
              placeholder="대분류(전체)"
              style="height: 32px; width: 180px; text-align: center; font-size: 12px; font-weight: 600; margin-left: 5px;"
              @input="majorChange"
            >
            </vue-select>
            <vue-select
              class="middle-class mr-5"
              label="title"            
              :options="middleClassList"
              :clearable="true"
              v-model="selectedMiddleClass"
              placeholder="중분류(전체)"
              style="height: 32px; width: 180px; text-align: center; font-size: 12px; font-weight: 600; margin-left: 5px;"
              @input="middleChange"
            >
              <template v-slot:no-options >
                <em style="opacity: 0.5; font-size: 12px;">대분류 항목을 선택하세요.</em>
              </template>
            </vue-select>
            <v-divider
              thickness="10"
              class="border-opacity-100"
              style="border-width: 1.2px; margin-top: 3px; margin-bottom: 1px; border-color: #d8d6de;"
              vertical
            />
            <b-button class="ml-5" id="analysis" style="height: 28px; width: 80px; padding: 0.5rem 0.85rem; margin-left: 5px;" @click="runAnalysis">
              분석하기
            </b-button>
          </b-row>
        </b-col>
        <b-col xl="2" md="2" sm="2"></b-col>        
        <b-col xl="2" md="2" sm="2">
          <b-row class="d-flex align-items-center justify-content-end">
            <b-button id="exp_pdf" style="height: auto; width: 40px; padding: 0.6rem 0.85rem; margin-right: 5px;" @click="exportToPDF">
              <div v-if="isPdfExporting" class="spinner-border spinner-border-sm"></div>
              <div v-else>
                <i class="fa-regular fa-file-pdf fa-lg"/>
              </div>
            </b-button>
            <b-tooltip target="exp_pdf" triggers="hover"> Export to PDF </b-tooltip>
            <b-button id="exp_xls" style="height: auto; width: 40px; padding: 0.6rem 0.85rem; margin-right: 5px;" @click="exportToExcel">
              <div v-if="isXlsExporting" class="spinner-border spinner-border-sm"></div>
              <div v-else>
                <i class="fa-regular fa-file-excel fa-lg"/>
              </div>
            </b-button>    
            <b-tooltip target="exp_xls" triggers="hover"> Export to Excel </b-tooltip>    
          </b-row>
        </b-col>
      </b-row>
    </b-card>

    <b-card ref="trdPrintArea1" class="mb-1" style="font-family: 'NanumBarunGothic'; padding: 0.2rem 1.5rem;" no-body>
      <b-row>
        <b-col cols="6" style="text-align: left; color:whitesmoke; font-size: 14px; margin-left: 1.0rem; margin-top: 1.0rem; padding: 5px; background-color:lightslategray; border-radius: 5px;">
          💡 카테고리 내에서 최근 관심을 받는 키워드를 분석하여, 떠오르는 브랜드와 카테고리 내 이슈를 파악할 수 있습니다. 
        </b-col>
      </b-row>
      <b-row style="margin-top: 20px; margin-left: 1.0rem;">
        <b-col xl="6" md="6" sm="6" style="margin-left: -10px;">
          <b-row>
            <b-col style="text-align: center; font-size: 2rem;">
              <h1>최근 검색량 및 변화량</h1>
            </b-col>
          </b-row>
          <b-row>
            <b-col style="text-align: left; color: #ea5455;">📢 표의 특정 브랜드 행을 선택하면 우측과 하단에 해당 내용이 표기 됩니다.</b-col>
          </b-row>
          <b-row>
            <b-col id="trendkeywordTableCol">
              <b-table
                class="tkTable position-relative"
                ref="refTrendKeywordTable"
                :items="fetchGroups"
                :fields="tableColumns"
                :busy="isBusy"
                :sort-desc.sync="sortDesc" 
                :sort-by.sync="sortBy"
                :sort-direction='sortDirection'
                responsive
                show-empty
                no-border-collapse
                outlined
                hover
                table-class="table-font-size"
                empty-text="해당하는 키워드가 없습니다."
                sticky-header="true"
                style="max-height: 44.5rem;"
                selectable
                select-mode="single"
                @row-selected="onRowSelected"
              >
                <template #head()="{ label, field: { key, sortable } }">
                  {{ label }}
                  <template v-if="sortable">
                    <b-img v-if="sortBy !== key" src="/caretupdown.png" style="width: 10px;"></b-img>
                    <b-img v-else-if="sortDesc" src="/caretup.png" style="width: 9px;"></b-img>
                    <b-img v-else src="/caretdown.png" style="width: 9px;"></b-img>
                  </template>
                </template>
                <template #table-busy>
                  <div class="text-center text-primary my-2">
                    <b-spinner class="align-middle mr-2"></b-spinner>
                    <strong>분석중...</strong>
                  </div>
                </template>

                <template v-if="total_row != null" v-slot:top-row>
                  <!-- <tr > -->
                    <td style="text-align: center;" @click="onRowSelectedTotal">{{ total_row.gubun }}</td>
                    <td style="text-align: right;" @click="onRowSelectedTotal">{{ total_row.thisFreq }}</td>
                    <td style="text-align: right;" @click="onRowSelectedTotal">{{ total_row.lastFreq }}</td>
                    <td style="text-align: right;" @click="onRowSelectedTotal">
                      <div
                        class="text-nowrap"
                        v-if="total_row.diffFreq < 0"
                        style="color: red;"
                      >
                      <img src="@/assets/images/etc/negative.png" style="width: 0.7rem;"/> {{ Math.abs(total_row.diffFreq).toLocaleString() }}
                      </div>
                      <div
                        class="text-nowrap"
                        v-else-if="total_row.diffFreq > 0"
                        style="color: green;"
                      >
                      <img src="@/assets/images/etc/positive.png" style="width: 0.7rem;"/> {{ total_row.diffFreq.toLocaleString() }}
                      </div>
                      <div
                        class="text-nowrap"
                        v-else-if="total_row.diffFreq == 0"
                        style="color: gray;"
                      >
                        <small><b>-</b></small>
                      </div>
                    </td>
                    <td style="text-align: right;" @click="onRowSelectedTotal">
                      <div
                        class="text-nowrap"
                        v-if="total_row.diffRate == null & total_row.diffFreq == 0"
                        style="color: gray;"
                      >
                      <small><b>-</b></small>
                      </div>
                      <div
                        class="text-nowrap"
                        v-else-if="total_row.diffRate < 0"
                        style="color: red;"
                      >
                        <img src="../../assets/images/etc/negative.png" style="width: 0.7rem;"/> {{ Math.abs(total_row.diffRate).toFixed(1) }}%
                      </div>
                      <div
                        class="text-nowrap"
                        v-else-if="total_row.diffRate > 0"
                        style="color: green;"
                      >
                        <img src="../../assets/images/etc/positive.png" style="width: 0.7rem;"/> {{ total_row.diffRate.toFixed(1) }}%
                      </div>
                      <div
                        class="text-nowrap"
                        v-else-if="total_row.diffRate == 0"
                        style="color: gray;"
                      >
                        {{ total_row.diffRate.toFixed(1) }}%
                      </div>
                    </td>
                  <!-- </tr> -->
                </template>

                <template #cell(diffFreq)="data">
                  <div
                    class="text-nowrap"
                    v-if="data.item.diffFreq < 0"
                    style="color: red;"
                  >
                  <img src="@/assets/images/etc/negative.png" style="width: 0.7rem;"/> {{ Math.abs(data.item.diffFreq).toLocaleString() }}
                  </div>
                  <div
                    class="text-nowrap"
                    v-else-if="data.item.diffFreq > 0"
                    style="color: green;"
                  >
                  <img src="@/assets/images/etc/positive.png" style="width: 0.7rem;"/> {{ data.item.diffFreq.toLocaleString() }}
                  </div>
                  <div
                    class="text-nowrap"
                    v-else-if="data.item.diffFreq == 0"
                    style="color: gray;"
                  >
                    <small><b>-</b></small>
                  </div>
                </template>
                <template #cell(diffRate)="data">
                  <div
                    class="text-nowrap"
                    v-if="data.item.diffRate == null & data.item.diffFreq == 0"
                    style="color: gray;"
                  >
                    <small><b>-</b></small>
                  </div>
                  <div
                    class="text-nowrap"
                    v-else-if="data.item.diffRate == null"
                    style="color: #1951DC;"
                  >
                    <small><b>신규</b></small>
                  </div>
                  <div
                    class="text-nowrap"
                    v-else-if="data.item.diffRate < 0"
                    style="color: red;"
                  >
                    <img src="../../assets/images/etc/negative.png" style="width: 0.7rem;"/> {{ Math.abs(data.item.diffRate).toFixed(1) }}%
                  </div>
                  <div
                    class="text-nowrap"
                    v-else-if="data.item.diffRate > 0"
                    style="color: green;"
                  >
                    <img src="../../assets/images/etc/positive.png" style="width: 0.7rem;"/> {{ data.item.diffRate.toFixed(1) }}%
                  </div>
                  <div
                    class="text-nowrap"
                    v-else-if="data.item.diffRate == 0"
                    style="color: gray;"
                  >
                    {{ data.item.diffRate.toFixed(1) }}%
                  </div>
                </template>
              </b-table>
            </b-col>
          </b-row>  
        </b-col>
        <b-col xl="6" md="6" sm="6">
          <b-row>
            <b-col xl="3" md="3" sm="3"></b-col>
            <b-col xl="6" md="6" sm="6" style="text-align: center; font-size: 2rem; ">
              <h1>키워드 검색량 변화</h1>
            </b-col>
            <b-col xl="3" md="3" sm="3"></b-col>
          </b-row>
          <b-row>
            <b-col xl="12" md="12" sm="12" style="text-align: center; color: #6B6B6B;">
              구분 : {{ this.selectedGubun }}
            </b-col>
          </b-row>
          <b-row>
            <b-col xl="12" md="12" sm="12" style="display: flex; justify-content: center; padding-bottom: 0.63rem;">
              <b-button-group>
                <b-button 
                  class="dsp-opt-btn" 
                  v-for="(btn, idx) in dsp_buttons"
                  :key="idx"
                  :pressed.sync="btn.state"
                  @click="filterLegendChange(idx)"
                >
                  {{ btn.caption }}
                </b-button>
              </b-button-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col id="trendkeywordBarCol" style="position: relative; min-height: 500px;">
              <div id="loadingBar" class="text-center text-primary my-2" style="position: absolute; top: 40%; left: 40%; display: block;">
                <b-spinner class="align-middle mr-2"></b-spinner>
                <strong>분석중...</strong>
              </div>              
              <div class="graphic-container" id="barChart" style="visibility: hidden;">
                  <div class="additional-info" id="additional-info">
                  </div>
                  <trend-keyword-chart-bar
                    :height="height"
                    :barChartData="barChartData"
                    :barChartCategory="barChartCategory"
                    :barChartDiff="barChartDiff"
                    :barChartNodata="barChartNodata"
                  />
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row style="margin-top: 5px; margin-left: 1.0rem;">
        <b-col xl="6" md="6" sm="6" style="margin-left: -10px;">
          <div v-if="!this.isBusy && this.total_row != null" style="border-width: 2px; border-color: #b4bec8; border-style: solid; border-radius: 5px; background-color: aliceblue; margin-bottom: 5px;">          
            <div style="text-align: left; color: #5e5873; font-size: 13px; margin: 5px;">
              <div v-if="this.total_row.diffRate > 0" style="margin-bottom: 4px;">
                • <b>{{ this.this_date }}</b> 월의 총 검색량은 <b>{{ this.total_row.thisFreq.toLocaleString() }}</b> 건으로 이전 달 대비 <img src="@/assets/images/etc/positive.png" style="width: 0.7rem"/> <b>{{ Math.abs(this.total_row.diffRate).toFixed(1) }}%</b> 증가 하였습니다.
              </div>
              <div v-else-if="this.total_row.diffRate < 0" style="margin-bottom: 4px;">
                • <b>{{ this.this_date }}</b> 월의 총 검색량은 <b>{{ this.total_row.thisFreq.toLocaleString() }}</b> 건으로 이전 달 대비 <img src="@/assets/images/etc/negative.png" style="width: 0.7rem"/> <b>{{ Math.abs(this.total_row.diffRate).toFixed(1) }}%</b> 감소 하였습니다.
              </div>
              <div v-else style="margin-bottom: 4px;">
                • <b>{{ this.this_date }}</b> 월의 총 검색량은 <b>{{ this.total_row.thisFreq.toLocaleString() }}</b> 건으로 이전 달과 동일합니다다.
              </div>
              <div v-if="this.nonBranded_diff_rate > 0" style="margin-bottom: 4px;">
                • <b>NONBRANDED</b> 검색량은 <b>{{ this.nonBranded_freq }}</b>건으로 이전 달 대비 <img src="@/assets/images/etc/positive.png" style="width: 0.7rem"/> <b>{{ Math.abs(this.nonBranded_diff_rate).toFixed(1) }}%</b> 증가 하였습니다.
              </div>
              <div v-else-if="this.nonBranded_diff_rate < 0" style="margin-bottom: 4px;">
                • <b>NONBRANDED</b> 검색량은 <b>{{ this.nonBranded_freq }}</b>건으로 이전 달 대비 <img src="@/assets/images/etc/negative.png" style="width: 0.7rem"/> <b>{{ Math.abs(this.nonBranded_diff_rate).toFixed(1) }}%</b> 감소 하였습니다.
              </div>
              <div v-else style="margin-bottom: 4px;">
                • <b>NONBRANDED</b> 검색량은 <b>{{ this.nonBranded_freq }}</b>건으로 이전 달과 동일합니다다.
              </div>
              <div style="color: #1951dc;">
                👉 지난 달, 우리 브랜드 검색량 변화를 TOTAL, NONBRANDED 및 경쟁 브랜드의 값과 비교해 보세요.
              </div>
            </div>
          </div>
        </b-col>
        <b-col xl="6" md="6" sm="6">
          <div v-if="!this.isBusy && this.fetchGroups != null" style="border-width: 2px; border-color: #b4bec8; border-style: solid; border-radius: 5px; background-color: aliceblue; margin-bottom: 5px;">          
            <div style="text-align: left; color: #5e5873; font-size: 13px; margin: 5px;">
              <div v-if="this.selectedFilterValue.id == 0" style="margin-bottom: 4px;">
                <div v-if="this.selectedGubun == 'TOTAL'" style="margin-bottom: 4px;">
                  <div v-if="this.barChartCategory.length == 1">
                    • <b>{{ this.sel_category_title }}</b> 검색어 중 가장 많이 검색된 키워드는 🥇<b>{{ this.barChartCategory[0] }}</b> 입니다.
                  </div>
                  <div v-else-if="this.barChartCategory.length == 2">
                    • <b>{{ this.sel_category_title }}</b> 검색어 중 가장 많이 검색된 키워드는 🥇<b>{{ this.barChartCategory[0] }}</b> 였으며, 그 뒤로 🥈<b>{{ this.barChartCategory[1] }}</b> 가 있습니다.
                  </div>
                  <div v-else-if="this.barChartCategory.length > 2">
                    • <b>{{ this.sel_category_title }}</b> 검색어 중 가장 많이 검색된 키워드는 🥇<b>{{ this.barChartCategory[0] }}</b> 였으며, 그 뒤로 🥈<b>{{ this.barChartCategory[1] }}</b>, 🥉<b>{{ this.barChartCategory[2] }}</b> 가 있습니다.
                  </div>
                </div>
                <div v-else style="margin-bottom: 4px;">
                  <div v-if="this.barChartCategory.length == 1">
                    • <b>{{ this.selectedGubun }}</b> 검색어 중 가장 많이 검색된 키워드는 🥇<b>{{ this.barChartCategory[0] }}</b> 입니다.
                  </div>
                  <div v-else-if="this.barChartCategory.length == 2">
                    • <b>{{ this.selectedGubun }}</b> 검색어 중 가장 많이 검색된 키워드는 🥇<b>{{ this.barChartCategory[0] }}</b> 였으며, 그 뒤로 🥈<b>{{ this.barChartCategory[1] }}</b> 가 있습니다.
                  </div>
                  <div v-else-if="this.barChartCategory.length > 2">
                    • <b>{{ this.selectedGubun }}</b> 검색어 중 가장 많이 검색된 키워드는 🥇<b>{{ this.barChartCategory[0] }}</b> 였으며, 그 뒤로 🥈<b>{{ this.barChartCategory[1] }}</b>, 🥉<b>{{ this.barChartCategory[2] }}</b> 가 있습니다.
                  </div>
                </div>                  
                <div style="color: #1951dc;">
                  👉 {{ this.this_date }} 월에 이 키워드들이 소비자에게 가장 많이 검색되었습니다.
                </div>
              </div>
              <div v-else-if="this.selectedFilterValue.id == 1 && this.sortedDiff.length > 0" style="margin-bottom: 4px;">
                <div v-if="this.selectedGubun == 'TOTAL'" style="margin-bottom: 4px;">
                  <div v-if="this.barChartCategory.length == 1">
                    • <b>{{ this.sel_category_title }}</b> 검색어 중 가장 많이 상승한 키워드는 🥇<b>{{ this.barChartCategory[this.sortedDiff[0].idx] }}</b> 입니다.
                  </div>
                  <div v-else-if="this.barChartCategory.length == 2">
                    • <b>{{ this.sel_category_title }}</b> 검색어 중 가장 많이 상승한 키워드는 🥇<b>{{ this.barChartCategory[this.sortedDiff[0].idx] }}</b> 였으며, 그 뒤로 🥈<b>{{ this.barChartCategory[this.sortedDiff[1].idx] }}</b> 가 있습니다.
                  </div>
                  <div v-else-if="this.barChartCategory.length > 2">
                    • <b>{{ this.sel_category_title }}</b> 검색어 중 가장 많이 상승한 키워드는 🥇<b>{{ this.barChartCategory[this.sortedDiff[0].idx] }}</b> 였으며, 그 뒤로 🥈<b>{{ this.barChartCategory[this.sortedDiff[1].idx] }}</b>, 🥉<b>{{ this.barChartCategory[this.sortedDiff[2].idx] }}</b> 가 있습니다.
                  </div>
                </div>
                <div v-else style="margin-bottom: 4px;">
                  <div v-if="this.barChartCategory.length == 1">
                    • <b>{{ this.selectedGubun }}</b> 검색어 중 가장 많이 상승한 키워드는 🥇<b>{{ this.barChartCategory[this.sortedDiff[0].idx] }}</b> 입니다.
                  </div>
                  <div v-else-if="this.barChartCategory.length == 2">
                    • <b>{{ this.selectedGubun }}</b> 검색어 중 가장 많이 상승한 키워드는 🥇<b>{{ this.barChartCategory[this.sortedDiff[0].idx] }}</b> 였으며, 그 뒤로 🥈<b>{{ this.barChartCategory[this.sortedDiff[1].idx] }}</b> 가 있습니다.
                  </div>
                  <div v-else-if="this.barChartCategory.length > 2">
                    • <b>{{ this.selectedGubun }}</b> 검색어 중 가장 많이 상승한 키워드는 🥇<b>{{ this.barChartCategory[this.sortedDiff[0].idx] }}</b> 였으며, 그 뒤로 🥈<b>{{ this.barChartCategory[this.sortedDiff[1].idx] }}</b>, 🥉<b>{{ this.barChartCategory[this.sortedDiff[2].idx] }}</b> 가 있습니다.
                  </div>
                </div> 
                <div style="color: #1951dc;">
                  👉 {{ this.last_date }} 월 대비, {{ this.this_date }}월에 이 키워드들의 검색량이 가장 크게 늘어났습니다.
                </div>
              </div>
              <div v-else-if="this.selectedFilterValue.id == 2 && this.sortedDiff.length > 0" style="margin-bottom: 4px;">
                <div v-if="this.selectedGubun == 'TOTAL'" style="margin-bottom: 4px;">
                  <div v-if="this.barChartCategory.length == 1">
                    • <b>{{ this.sel_category_title }}</b> 검색어 중 가장 많이 하락한 키워드는 🥇<b>{{ this.barChartCategory[this.sortedDiff[this.sortedDiff.length - 1].idx] }}</b> 입니다.
                  </div>
                  <div v-else-if="this.barChartCategory.length == 2">
                    • <b>{{ this.sel_category_title }}</b> 검색어 중 가장 많이 하락한 키워드는 🥇<b>{{ this.barChartCategory[this.sortedDiff[this.sortedDiff.length - 1].idx] }}</b> 였으며, 그 뒤로 🥈<b>{{ this.barChartCategory[this.sortedDiff[this.sortedDiff.length - 2].idx] }}</b> 가 있습니다.
                  </div>
                  <div v-else-if="this.barChartCategory.length > 2">
                    • <b>{{ this.sel_category_title }}</b> 검색어 중 가장 많이 하락한 키워드는 🥇<b>{{ this.barChartCategory[this.sortedDiff[this.sortedDiff.length - 1].idx] }}</b> 였으며, 그 뒤로 🥈<b>{{ this.barChartCategory[this.sortedDiff[this.sortedDiff.length - 2].idx] }}</b>, 🥉<b>{{ this.barChartCategory[this.sortedDiff[this.sortedDiff.length - 3].idx] }}</b> 가 있습니다.
                  </div>
                </div>
                <div v-else style="margin-bottom: 4px;">
                  <div v-if="this.barChartCategory.length == 1">
                    • <b>{{ this.selectedGubun }}</b> 검색어 중 가장 많이 하락한 키워드는 🥇<b>{{ this.barChartCategory[this.sortedDiff[this.sortedDiff.length - 1].idx] }}</b> 입니다.
                  </div>
                  <div v-else-if="this.barChartCategory.length == 2">
                    • <b>{{ this.selectedGubun }}</b> 검색어 중 가장 많이 하락한 키워드는 🥇<b>{{ this.barChartCategory[this.sortedDiff[this.sortedDiff.length - 1].idx] }}</b> 였으며, 그 뒤로 🥈<b>{{ this.barChartCategory[this.sortedDiff[this.sortedDiff.length - 2].idx] }}</b> 가 있습니다.
                  </div>
                  <div v-else-if="this.barChartCategory.length > 2">
                    • <b>{{ this.selectedGubun }}</b> 검색어 중 가장 많이 하락한 키워드는 🥇<b>{{ this.barChartCategory[this.sortedDiff[this.sortedDiff.length - 1].idx] }}</b> 였으며, 그 뒤로 🥈<b>{{ this.barChartCategory[this.sortedDiff[this.sortedDiff.length - 2].idx] }}</b>, 🥉<b>{{ this.barChartCategory[this.sortedDiff[this.sortedDiff.length - 3].idx] }}</b> 가 있습니다.
                  </div>
                </div> 
                <div style="color: #1951dc;">
                  👉 {{ this.last_date }} 월 대비, {{ this.this_date }}월에 이 키워드들의 검색량이 가장 크게 줄었습니다.
                </div>
              </div>
              <div v-else style="margin-bottom: 4px;">
                <div v-if="this.barChartCategory.length == 1">
                  • 새롭게 <b>{{ this.sel_category_title }}</b> 관련 검색어로 등장한 키워드는 🥇<b>{{ this.barChartCategory[0] }}</b> 입니다.
                </div>
                <div v-else-if="this.barChartCategory.length == 2">
                  • 새롭게 <b>{{ this.sel_category_title }}</b> 관련 검색어로 등장한 키워드는 🥇<b>{{ this.barChartCategory[0] }}</b> 였으며, 그 뒤로 🥈<b>{{ this.barChartCategory[1] }}</b> 가 있습니다.
                </div>
                <div v-else-if="this.barChartCategory.length > 2">
                  • 새롭게 <b>{{ this.sel_category_title }}</b> 관련 검색어로 등장한 키워드는 🥇<b>{{ this.barChartCategory[0] }}</b> 였으며, 그 뒤로 🥈<b>{{ this.barChartCategory[1] }}</b>, 🥉<b>{{ this.barChartCategory[2] }}</b> 가 있습니다.
                </div>
                <div v-else-if="this.barChartCategory.length == 0">
                  • {{ this.this_date }} 월에 신규로 등장한 키워드가 없습니다.
                </div>
                <div v-if="this.barChartCategory.length > 0" style="color: #1951dc;">
                  👉 {{ this.this_date }} 월에 이 키워드들이 소비자에게 관심을 받기 시작했습니다.
                </div>
              </div>
            </div>
          </div>          
        </b-col>
      </b-row>
    </b-card>
    
    <b-card ref="trdPrintArea2" class="mb-0" style="font-family: 'NanumBarunGothic'; padding: 0.2rem 1.5rem;" no-body>
      <b-row style="margin-top: 1rem;">
        <b-col style="text-align: center; font-size: 2rem;">
          <h1>검색량 상위 키워드 트래킹</h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col style="text-align: center; color: #6B6B6B; margin-bottom: 0.3rem;">
          {{ this.mapHistory }}
        </b-col>
      </b-row>
      <b-row>
        <b-col style="text-align: center; color: #ea5455; margin-bottom: 1rem;">
          📢 최근 검색량 및 변화량 차트의 행 또는 키워드 검색량 변화의 값을 선택하시면 해당하는 키워드를 확인할 수 있습니다.
        </b-col>
      </b-row>
      <b-row>
        <b-col id="trendkeywordLineCol" style="position: relative; min-height: 500px;">
          <div id="loadingLine" class="text-center text-primary my-2" style="position: absolute; top: 40%; left: 45%; visibility: visible;">
            <b-spinner class="align-middle mr-2"></b-spinner>
            <strong>분석중...</strong>
          </div>
          <div class="graphic-container" id="lineChart" style="visibility: hidden;">
            <trend-keyword-chart-line
              :trendkeywordChartLine="trendkeywordChartLineSeries(lineChartData)"
              :lineChartCategories="lineChartCategories"
              :lineChartDesc="lineChartDesc"
              :isChartInit="lnChartInit"
              id="trendkeywordChartLine"
            />
          </div>
        </b-col>
      </b-row>
    </b-card>
  </section>
</template>



<script>
import { 
    BCard, 
    BCol, 
    BRow, 
    BCardBody, 
    BButton,
    BButtonGroup,
    BCardText,
    BFormRadio, 
    BTable, 
    BPagination,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BTooltip,
    BImg,
} from "bootstrap-vue";

import FlatPickr from "vue-flatpickr-component";
import vSelect from "vue-select";
import moment from "moment";
import ToastificationContent from "@core/components/toastification/ToastificationContent";

import TrendKeywordChartBar from "@/views/cis-trendkeyword/components/TrendKeywordChartBar.vue";
import TrendKeywordChartLine from "@/views/cis-trendkeyword/components/TrendKeywordChartLine.vue";

import CisTrendKeywordService from "@/services/cis-trendkeyword.service";
import CategoryService from "@/services/category.service";

import ExportPDF from "@/components/pdfExport";
import debounce from "lodash";

import * as XLSX from 'xlsx';

import axios from "axios"

const stringStyle = { font: { name: 'Consolas' } };
const indexNumStyle = { font: { name: 'Consolas' }, numFmt: "0" };
const intNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0" };
const intNumColorStyle = { font: { name: 'Consolas' }, numFmt: "[Blue]\\ \\▲#,##0;[Red]\\ \\▼#,##0;[Black]\\ \"-\"" };
const floatNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0.0" };
const rateNumStyle = { font: { name: 'Consolas' }, numFmt: "#,##0.0%" };
const rateNumColorStyle = { font: { name: 'Consolas' }, numFmt: "[Blue]\\ \\▲#,##0%;[Red]\\ \\▼#,##0%;[Black]\\ \"-\"" };

const boldStyle = { font: { name: 'Consolas', bold: true } };
const underlineStyle = { font: { name: 'Consolas', underline: true} };

const sleep = delay => new Promise(resolve => setTimeout(resolve, delay));

const cancelToken = axios.CancelToken;
var source = cancelToken.source();

var sel_category = '9999';

export default {
  name: "TrendKeyword",
  components: {
    FlatPickr,
    BCard,
    BCol,
    BRow,
    BCardBody,
    vSelect,
    BButton,
    BButtonGroup,
    BTable,
    BPagination,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BTooltip,
    BImg,

    TrendKeywordChartBar,
    TrendKeywordChartLine,
  },
  data() {
    return {
      isPdfExporting: false,
      isXlsExporting: false,

      isBusy: false,

      donutChartData: [],
      barChartData: [],
      barChartCategory: [],
      barChartDiff: [],
      height: 0,
      barChartNodata: 1,

      majorCategory: [],
      criteria: [
        {
          id: 0,
          title: "브랜드"
        },
        {
          id: 1,
          title: "라인 브랜드"
        },
        {
          id: 2,
          title: "대분류"
        },
        {
          id: 3,
          title: "중분류"
        }
      ],
      displayValue: [
        {
          id: 0,
          title: "빈도(Freq)"
        },
        {
          id: 1,
          title: "비율(%)"
        }
      ],
      filterValue: [
        {
          id: 0,
          title: "상위"
        },
        {
          id: 1,
          title: "상승"
        },
        {
          id: 2,
          title: "하락"
        },
        {
          id: 3,
          title: "신규 등장"
        }
      ],

      dsp_buttons: [
          { caption: '상위', state: true },
          { caption: '상승', state: false },
          { caption: '하락', state: false },
          { caption: '신규 등장', state: false }
        ],

      selectedMajorCategory: "",
      selectedCriteria: "",
      selectedDisplayValue: "",
      selectedFilterValue: "",

      presenceData: {
        dateType: "m"
      },

      tableColumns: [
        { key: 'gubun', label: '구분', sortable: true},
        { key: 'thisFreq', label: '검색량', sortable: true },
        { key: 'lastFreq', label: '검색량', sortable: true },
        { key: 'diffFreq', label: '비교', sortable: true },
        { key: 'thisRate', label: '검색량', sortable: true },
        { key: 'lastRate', label: '검색량', sortable: true },
        { key: 'diffRate', label: '비교', sortable: true },
      ],

      fetchGroups: null,
      total_row: null,

      selectedGubun: "TOTAL",
      
      mapHistory: "TOTAL",

      lineChartCategories: [],
      lineChartData: [],
      lineChartDesc: [],

      lnChartInit: false,

      sel_category_title: "",
      this_date: "",
      last_date: "",
      nonBranded_freq: 0,
      nonBranded_diff_rate: 0.0,

      sortedDiff: [],

      sortBy: null,
      sortDesc: false,
      sortDirection: 'desc',

      majorClassList: [],
      middleClassList: [],
      selectedMajorClass: null,
      selectedMiddleClass: null,
    };
  },
  computed: {
    check_selectedCategory() {
      return this.$store.getters.getSelectedCategory
    },

    check_selectedTrendKeyword() {
      return this.$store.getters.getSelectedTrendKeyword
    },
  },
  watch: {
    sortDesc(val) {
      if(val)
        this.sortBy = null
    },

    check_selectedCategory(val) {
      console.log('---------- watch // check_selectedCategory ----------')
      console.log(' sel category : ' + val)
      console.log(' cur category : ' + sel_category)

      if (sel_category != val) {
        this.abort(true, 'change category')

        sel_category = val;

        this.selectedCriteria = this.criteria[0];
        this.selectedDisplayValue = this.displayValue[0];
        this.selectedFilterValue = this.filterValue[0];

        for (var btn_idx = 0; btn_idx < this.dsp_buttons.length; btn_idx++) 
        {
          if (btn_idx == 0)
            this.dsp_buttons[btn_idx].state = true;
          else
            this.dsp_buttons[btn_idx].state = false;
        }

        this.runAnalysis();
        this.setMajorClasses();
      }
    },

    check_selectedTrendKeyword(val) {
      this.mapHistory = this.selectedGubun + " > " + val
      this.loadTrandKeywordDataLine([val])
    },

    selectedDisplayValue(){
      this.toggleColumns()
    },

    selectedFilterValue(){
      if(this.$store.getters.getSelectedCategory != '9999'){
        this.loadDataBar()
      }
    },

    selectedGubun(){
      if(this.$store.getters.getSelectedCategory != '9999'){
        this.loadDataBar();
      }
    }

  },
  methods: {
    filterLegendChange(selLegendIdx) {
      for (var btn_idx = 0; btn_idx < this.dsp_buttons.length; btn_idx++) {
        if (btn_idx == selLegendIdx)
          continue

        this.dsp_buttons[btn_idx].state = false;
      }

      this.selectedFilterValue = this.filterValue[selLegendIdx]

      console.log('-- filterLegendChange --')
      console.log(this.selectedFilterValue)
    },

    async loadDataTable(){
      console.log('loadDataTable')

      this.isBusy = true
      this.sel_category_title = ""
      this.this_date = ""
      this.last_date = ""

      var sel_Major = this.selectedMajorClass != null ? this.selectedMajorClass.title : null; 
      var sel_Middle = this.selectedMiddleClass != null ? this.selectedMiddleClass : null; 

      if (sel_Middle == '중분류 없음')
        sel_Middle = '기타'

      const response = await CisTrendKeywordService.getTrendKeywordDataTable({
        thisMonthStart : moment(moment().add(-1, 'month').toDate()).format("YYYY-MM"),
        lastMonthStart : moment(moment().add(-2, 'month').toDate()).format("YYYY-MM"),
        thisMonthEnd : moment(moment().add(-1, 'month').toDate()).format("YYYY-MM"),
        lastMonthEnd : moment(moment().add(-2, 'month').toDate()).format("YYYY-MM"),
        ctgSq : this.$store.getters.getSelectedCategory,
        criteria : this.selectedCriteria.id,
        selMajor: sel_Major, 
        selMiddle: sel_Middle
      }, source);

      if (response && response.status === 200) {
        console.log(response)

        this.isBusy = false
        this.fetchGroups = null
        this.fetchGroups = response.data.data

        this.total_row = null

        if (this.fetchGroups.length > 0) {
          this.total_row = this.fetchGroups.shift()

          for(var item of this.fetchGroups) {
            if (item.gubun == 'NONBRANDED'){
              item._rowVariant = 'nonbranded'
            }
            if(this.selectedCriteria.title == '중분류'){
              if(item.gubun == '기타'){
                item.gubun = '중분류 없음'
              }
            }
          }
        }

        const catServResp = await CategoryService.getOneCategory(this.$store.getters.getSelectedCategory, source);
         
        if (catServResp.data.success)
          this.sel_category_title = catServResp.data.data.title;

        this.this_date = moment(moment().add(-1, 'month').toDate()).format("YYYY-MM")
        this.last_date = moment(moment().add(-2, 'month').toDate()).format("YYYY-MM")

        for (var item of response.data.data) {
          if (item.gubun == 'NONBRANDED') {
            this.nonBranded_freq = item.thisFreq;
            this.nonBranded_diff_rate = item.diffRate;
          }
        }
      }
    },

    toggleColumns(){
      if(this.selectedDisplayValue.id == 0){
        this.tableColumns = [
          { key: 'gubun', label: '구분', sortable: false, thClass: 'text-center', thStyle: {width: '15%'}, tdClass: 'text-center' },
          { key: 'thisFreq', label: moment(moment().add(-1, 'month').toDate()).format("'YY-MM") + ' 검색량', sortable: true, thClass: 'text-right', thStyle: {width: '18%'}, tdClass: 'text-right' },
          { key: 'lastFreq', label: moment(moment().add(-2, 'month').toDate()).format("'YY-MM") + ' 검색량', sortable: true, thClass: 'text-right', thStyle: {width: '18%'}, tdClass: 'text-right' },
          { key: 'diffFreq', label: moment(moment().add(-2, 'month').toDate()).format("'YY-MM") + ' 대비 GAP', sortable: true, thClass: 'text-right', thStyle: {width: '24%'}, tdClass: 'text-right' },
          { key: 'diffRate', label: moment(moment().add(-2, 'month').toDate()).format("'YY-MM") + ' 대비 GAP %', sortable: true, thClass: 'text-right', thStyle: {width: '24%'}, tdClass: 'text-right' },
        ]
      }else{
        this.tableColumns = [
          { key: 'gubun', label: '구분', sortable: false, thClass: 'text-left' },
          { key: 'thisRate', label: moment(moment().add(-1, 'month').toDate()).format("YY년 MM월") + ' 검색비율', sortable: true, thClass: 'text-left', tdClass: 'text-right' },
          { key: 'lastRate', label: moment(moment().add(-2, 'month').toDate()).format("YY년 MM월") + ' 검색비율', sortable: true, thClass: 'text-left', tdClass: 'text-right' },
          { key: 'diffRate', label: moment(moment().add(-2, 'month').toDate()).format("YY년 MM월") + ' 대비 Gap', sortable: true, thClass: 'text-left', tdClass: 'text-right' },
        ]
      }
    },

    async onRowSelected(item){
      console.log('onRowSelected')
      if(item.length > 0){
        this.selectedGubun = item[0].gubun
        this.mapHistory = this.selectedGubun
      }
    },

    async onRowSelectedTotal(){
      console.log('onRowSelectedTotal')
      this.selectedGubun = 'TOTAL'
      this.mapHistory = this.selectedGubun
      this.$refs.refTrendKeywordTable.clearSelected()
    },

    async loadDataBar(){
      console.log('-- loadDataBar --')
      document.getElementById('loadingBar').style.visibility = "visible";
      document.getElementById('barChart').style.visibility = "hidden";

      document.getElementById('loadingLine').style.visibility = "visible";
      document.getElementById('lineChart').style.visibility = "hidden";

      this.barChartData = []
      this.barChartCategory = []
      this.barChartDiff = []
      this.sortedDiff = []
      this.barChartNodata = 1

      // 카테고리 정보가 설정되지 않은 경우 리턴
      if (sel_category == '9999' && this.$store.getters.getSelectedCategory == '9999') 
        return;

      const info_div = document.getElementById('additional-info');

      info_div.textContent = "";

      var sel_Major = this.selectedMajorClass != null ? this.selectedMajorClass.title : null; 
      var sel_Middle = this.selectedMiddleClass != null ? this.selectedMiddleClass : null; 

      if (sel_Middle == '중분류 없음')
        sel_Middle = '기타'

      var gubun = this.selectedGubun
      if (gubun == '중분류 없음')
        gubun = '기타'

      const response = await CisTrendKeywordService.getTrendKeywordDataBar({
        thisMonthStart : moment(moment().add(-1, 'month').toDate()).format("YYYY-MM"),
        lastMonthStart : moment(moment().add(-2, 'month').toDate()).format("YYYY-MM"),
        thisMonthEnd : moment(moment().add(-1, 'month').toDate()).format("YYYY-MM"),
        lastMonthEnd : moment(moment().add(-2, 'month').toDate()).format("YYYY-MM"),
        ctgSq : this.$store.getters.getSelectedCategory,
        criteria : this.selectedCriteria.id,
        gubun: gubun,
        filter: this.selectedFilterValue.id,
        selMajor: sel_Major, 
        selMiddle: sel_Middle
      }, source);

      if (response && response.status === 200) {
        console.log(response)
        document.getElementById('loadingBar').style.visibility = "hidden";
        document.getElementById('barChart').style.visibility = "visible";
       
        // bar chart update
        this.barChartData = []
        this.barChartCategory = []
        this.barChartDiff = []
        this.sortedDiff = []

        var keywordList = []
        var idx = 0

        info_div.textContent = "";

        if (response.data.data.length > 0){
          this.barChartNodata = 1
        }else{
          this.barChartNodata = 0
        }

        for(const item of response.data.data) {
          this.barChartCategory.push(item.keyword)
          this.barChartDiff.push(item.diffFreq)
          this.barChartData.push(item.thisFreq)

          const li = document.createElement("li");
          var div = document.createElement('div');
          
          if (item.diffFreq < 0){
            div.setAttribute('style', 'font-size: 12px; font-weight: 600; color: red;');
            var image = document.createElement('img');
            image.setAttribute('src', '/negative.png');
            image.setAttribute('width', '10px');
            var text = ' ' + Math.abs(item.diffFreq).toLocaleString()
            var textNode = document.createTextNode(text);
            div.appendChild(image)
            div.appendChild(textNode)
          }
          else if(item.diffFreq > 0)
          {
            div.setAttribute('style', 'font-size: 12px; font-weight: 600; color: green;');
            var image = document.createElement('img');
            image.setAttribute('src', '/positive.png');
            image.setAttribute('width', '10px');
            var text = ' ' + item.diffFreq.toLocaleString()
            var textNode = document.createTextNode(text);
            div.appendChild(image)
            div.appendChild(textNode)
          }
          else {
            div.setAttribute('style', 'font-size: 12px; color: gray;');
            var text = ' ' + item.diffFreq.toLocaleString()
            var textNode = document.createTextNode(text);
            div.appendChild(textNode)
          }

          li.appendChild(div)
          info_div.appendChild(li);

          if (keywordList.length < 20)
            keywordList.push(item.keyword)

            this.sortedDiff.push({idx: idx++, value:item.diffFreq})
        }
        
        // 전월, 전전월 검색량 차이값 기준으로 내림차순 정렬
        this.sortedDiff.sort((a, b) => {
          if (a.value > b.value) return -1;
          if (a.value === b.value) return 0;
          if (a.value < b.value) return 1;
        })

        this.loadTrandKeywordDataLine(keywordList)
      }

      // document.getElementById('loadingBar').style.display = "none";
      // document.getElementById('barChart').style.display = "block";

    },

    trendkeywordChartLineSeries(cd) {
      const chartSeries = [];

      for (const item of cd) {
        chartSeries.push({
          name: item.name,
          type: item.type,
          data: item.data,
          hidden: item.hidden
        })
      }

      return chartSeries;
    },

    async loadTrandKeywordDataLine(keywordList){

      console.log('----- loadTrandKeywordDataLine -----')

      document.getElementById('loadingLine').style.visibility = "visible";
      document.getElementById('lineChart').style.visibility = "hidden";

      var lineNum = 0
      this.lineChartData = []
      this.lineChartCategories = []
      this.lineChartDesc = []
      this.lnChartInit = false;

      var prev_month_dt = moment().add(-1, 'month').format("YYYY-MM")

      var en_dt = moment().add(-2, 'day').format("YYYY-MM-DD")
      var st_dt = moment(prev_month_dt).startOf('month').format("YYYY-MM-DD")

      var sel_Major = this.selectedMajorClass != null ? this.selectedMajorClass.title : null; 
      var sel_Middle = this.selectedMiddleClass != null ? this.selectedMiddleClass : null; 

      if (sel_Middle == '중분류 없음')
        sel_Middle = '기타'

      const response = await CisTrendKeywordService.getLatestMonthSearchVolume({ 
        st_dt: st_dt, 
        en_dt: en_dt, 
        filterKeywords: keywordList,
        ctgSq : this.$store.getters.getSelectedCategory,
        selMajor: sel_Major, 
        selMiddle: sel_Middle
      }, source);

      console.log(response)        

      if (response && response.status === 200) {
        this.lineChartData = []
        this.lineChartCategories = []
        this.lineChartDesc = []

        for(const item of response.data.data) {
          lineNum += 1

          if(lineNum < 6)
          {
            this.lineChartData.push({
              name: item.keyword,
              type: 'line',
              data: item.freq.split(','),
              hidden: false
            })
          }else{
            this.lineChartData.push({
              name: item.keyword,
              type: 'line',
              data: item.freq.split(','),
              hidden: true
            })
          }
              
          if (this.lineChartCategories.length == 0) {
            this.lineChartCategories = item.date.split(',')
          }

          this.lineChartDesc.push(item.freq.split(','))
        }
      }

      this.lnChartInit = true;
      document.getElementById('loadingLine').style.visibility = "hidden";
      document.getElementById('lineChart').style.visibility = "visible";
    },

    majorChange() {
      console.log('---------- major change ----------')

      if (this.selectedMajorClass != null) {
        this.setMiddleClasses();
      }
      else {
        this.middleClassList = [];
        this.selectedMiddleClass = null;
      }
    },

    middleChange() {
      console.log('---------- middle change ----------')
    },

    getToday() {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
      let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()

      return year + month + day
    },

    exportToPDF: _.debounce(async function() {
      this.isPdfExporting = true;

      await sleep(1);

      var ret = await ExportPDF.exportToPDF([this.$refs.trdPrintArea1, this.$refs.trdPrintArea2], 'a4', 'l', 'category_trend_' + this.getToday() + '.pdf');

      if (ret) {
        this.$toast({
            component: ToastificationContent,
            props: {
              title: "PDF export complete!!",
              icon: "EditIcon",
              variant: "success",
            },
          });
      }
      else {
        this.$toast({
            component: ToastificationContent,
            props: {
              title: "PDF export fail!!",
              icon: "AlertCircleIcon",
              variant: "warning",
            },
          });
      }

      this.isPdfExporting = false;
    }, 100),

    newSheet4Intro(dataOrigin, category, criteria, period, serviceName) {
      var tmp_sheet = []

      tmp_sheet.push([]);
      tmp_sheet.push(['', { v: 'CONSUMER in SEARCH Ai', t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { t: "s", v: "consumerinsearch.com", l: {Target: "https://consumerinsearch.com"}, s: underlineStyle}]);
      tmp_sheet.push([]);
      tmp_sheet.push(['', { v: '데이터 개요', t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { v: '데이터 출처: ', t: "s", s: boldStyle }, { v: dataOrigin, t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { v: '카테고리: ', t: "s", s: boldStyle }, { v: category, t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { v: '구분기준: ', t: "s", s: boldStyle }, { v: criteria, t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { v: '분석 기간: ', t: "s", s: boldStyle }, { v: period, t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { v: '서비스명: ', t: "s", s: boldStyle }, { v: serviceName, t: "s", s: boldStyle }]);

      var ws = XLSX.utils.aoa_to_sheet(tmp_sheet)
      ws['!cols'] = this.autoFit(tmp_sheet)

      return ws;
    },

    newSheet4Data(dataOrigin, category, criteria, period, columns, data) {
      var tmp_sheet = [];

      // Information
      tmp_sheet.push([{ v: '데이터 출처: ', t: "s", s: boldStyle }, { v: dataOrigin, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '카테고리: ', t: "s", s: boldStyle }, { v: category, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '구분기준: ', t: "s", s: boldStyle }, { v: criteria, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '분석 기간: ', t: "s", s: boldStyle }, { v: period, t: "s", s: boldStyle }]);
      tmp_sheet.push([]);

      // Header
      var header_list = ['No.', '키워드'].concat(columns)
      var tmp_header = [];

      for (const col_nm of header_list)
        tmp_header.push({ v: col_nm, t: "s", s: boldStyle });

      tmp_sheet.push(tmp_header);

      // Data
      var id = 1;
      var totalRow = null;

      for (const idx in data) {
        if (data[idx].gubun == 'TOTAL') {
          totalRow = data[idx];
          continue;
        }
           
        var tmp_row = [];
        tmp_row.push(Number(id));                                                                           // No.
        tmp_row.push(data[idx].gubun);                                                                      // 키워드
        tmp_row.push({ t: "n", v: Number(data[idx].thisFreq.trim().replaceAll(',', '')), s: intNumStyle }); // 전월 검색량
        tmp_row.push({ t: "n", v: Number(data[idx].lastFreq.trim().replaceAll(',', '')), s: intNumStyle }); // 전전월 검색량
        tmp_row.push({ t: "n", v: Number(data[idx].diffFreq), s: intNumColorStyle });                       // 전전월 대비 전월 검색량 차이
        tmp_row.push({ t: "n", v: Number(data[idx].diffRate) / 100, s: rateNumColorStyle });                // 전전월 대비 전월 검색량 비율

        tmp_sheet.push(tmp_row)

        id++;
      }

      if (totalRow != null) {
        var tmp_row = [''];

        tmp_row.push('Total');                                                                              // 키워드
        tmp_row.push({ t: "n", v: Number(totalRow.thisFreq.trim().replaceAll(',', '')), s: intNumStyle });  // 전월 검색량
        tmp_row.push({ t: "n", v: Number(totalRow.lastFreq.trim().replaceAll(',', '')), s: intNumStyle });  // 전전월 검색량
        tmp_row.push({ t: "n", v: Number(totalRow.diffFreq), s: intNumColorStyle });                        // 전전월 대비 전월 검색량 차이
        tmp_row.push({ t: "n", v: Number(totalRow.diffRate) / 100, s: rateNumColorStyle });                 // 전전월 대비 전월 검색량 비율

        tmp_sheet.push([]);
        tmp_sheet.push(tmp_row);
      }
      
      var ws = XLSX.utils.aoa_to_sheet(tmp_sheet)
      ws['!cols'] = this.autoFit(tmp_sheet)

      return ws;
    },

    newSheet4TopRankKeywords(dataOrigin, category, criteria, period, gubun, filter, columns, data) {
      var tmp_sheet = [];

      // Information
      tmp_sheet.push([{ v: '데이터 출처: ', t: "s", s: boldStyle }, { v: dataOrigin, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '카테고리: ', t: "s", s: boldStyle }, { v: category, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '구분기준: ', t: "s", s: boldStyle }, { v: criteria, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '분석 기간: ', t: "s", s: boldStyle }, { v: period, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '구분: ', t: "s", s: boldStyle }, { v: gubun == 'TOTAL' ? '상위' : gubun, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '값: ', t: "s", s: boldStyle }, { v: filter == '상위' ? '검색량' : filter, t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { v: '*검색량 상위 키워드는 최대 500개까지 제공됩니다.', t: "s", s: boldStyle } ]);

      tmp_sheet.push([]);

      // Header
      var header_list = ['No.', '키워드'].concat(columns)
      var tmp_header = [];

      for (const col_nm of header_list) {
        tmp_header.push({ v: col_nm, t: "s", s: boldStyle });
      };

      tmp_sheet.push(tmp_header);

      // Data
      for (const idx in data) {         
        var tmp_row = [];
        tmp_row.push(Number(idx) + 1);                                            // No.
        tmp_row.push(data[idx].keyword);                                          // 키워드
        tmp_row.push({ t: "n", v: Number(data[idx].prev1Freq), s: intNumStyle }); // 전월 검색량
        tmp_row.push({ t: "n", v: Number(data[idx].prev2Freq), s: intNumStyle }); // 전전월 검색량
        tmp_row.push({ t: "n", v: Number(data[idx].diff), s: intNumColorStyle }); // 전전월 대비 전월 검색량 차이        
        tmp_row.push(data[idx].brand);                                            // 브랜드

        tmp_sheet.push(tmp_row)
      }

      var ws = XLSX.utils.aoa_to_sheet(tmp_sheet)
      ws['!cols'] = this.autoFit(tmp_sheet)

      return ws;
    },

    newSheet4TopRankKeywordsTracking(dataOrigin, category, criteria, period, gubun, columns, data) {
      var tmp_sheet = [];
      var dailyFreqTotal = [];

      // Information
      tmp_sheet.push([{ v: '데이터 출처: ', t: "s", s: boldStyle }, { v: dataOrigin, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '카테고리: ', t: "s", s: boldStyle }, { v: category, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '구분기준: ', t: "s", s: boldStyle }, { v: criteria, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '분석 기간: ', t: "s", s: boldStyle }, { v: period, t: "s", s: boldStyle }]);
      tmp_sheet.push([{ v: '구분: ', t: "s", s: boldStyle }, { v: gubun == 'TOTAL' ? '상위' : gubun, t: "s", s: boldStyle }]);
      tmp_sheet.push(['', { v: '*검색량 상위 키워드는 최대 500개까지 제공됩니다.', t: "s", s: boldStyle } ]);

      tmp_sheet.push([]);

      // Header
      var header_list = ['No.', '키워드'].concat(columns)
      var tmp_header = [];

      header_list.push('Total')

      for (const col_nm of header_list) {
        tmp_header.push({ v: col_nm, t: "s", s: boldStyle });
        dailyFreqTotal.push(0);
      };

      tmp_sheet.push(tmp_header);

      // 검색량 Data
      for (const idx in data) {
        var tmp_row = [];
        tmp_row.push({t: "n", v: Number(idx) + 1, s: indexNumStyle}); // No.
        tmp_row.push({t: "s", v: data[idx].keyword, s: stringStyle}); // 키워드

        var sub_idx = 0;
        var keywordFreqTotal = 0;
        for (const sub_item of data[idx].freq) {  // 검색량
            tmp_row.push({t: "n", v: Number(sub_item), s: intNumStyle});

            keywordFreqTotal += Number(sub_item); // 키워드 검색량 합계
            dailyFreqTotal[sub_idx] += Number(sub_item); // 일간 검색량 합계
            sub_idx++;
        };

        tmp_row.push({t: "n", v: Number(keywordFreqTotal), s: intNumStyle});

        tmp_sheet.push(tmp_row)
      }

      var freqTotalRow = ['', 'Total'];

      for (const idx in columns)
        freqTotalRow.push({t: "n", v: Number(dailyFreqTotal[idx]), s: intNumStyle});

      tmp_sheet.push([]);
      tmp_sheet.push(freqTotalRow);

      var ws = XLSX.utils.aoa_to_sheet(tmp_sheet)
      ws['!cols'] = this.autoFit(tmp_sheet)

      return ws;
    },

    autoFit(data) {
      const wsCols = [];

      data.map((item) => {
        Object.keys(item).map((key, index) => {
          let text = item[key];
          let maxWidth;

          switch(typeof text) {
            case 'number':
              if (wsCols[index]) {
                if (text)
                  maxWidth = wsCols[index].width > 10 ? wsCols[index].width : 10;
                else
                  maxWidth = 10;
              }
              else
                maxWidth = text !== null ? 10 : 0;
                         
              break;
            case 'object':
              if (wsCols[index]) {
                if (text && text['v']) {
                  if (typeof text['v'] === 'number')
                    maxWidth = wsCols[index].width > 10 ? wsCols[index].width : 10;
                  else
                    maxWidth = wsCols[index].width < text['v'].length * 1.5 ? text['v'].length * 1.5 : wsCols[index].width;
                }
                else
                  maxWidth = wsCols[index].width;
              }
              else {
                if (text && text['v']) {
                  if (typeof text['v'] === 'number')
                    maxWidth = text['v'] !== null ? 10 : 0;
                  else
                    maxWidth = text['v'] !== null ? text['v'].length * 1.5 : 0;
                }
                else
                    maxWidth = 0;
              }

              break;
            case 'string':
              if (wsCols[index]) {
                if (text)
                  maxWidth = wsCols[index].width < text.length * 1.5 ? text.length * 1.5 : wsCols[index].width;
                else 
                  maxWidth = wsCols[index].width;
              }
              else 
                maxWidth = text !== null ? text.length * 1.5 : 0;
               
              break;
          }

          wsCols[index] = {width : maxWidth}
        })
      })

      for (var index in wsCols)
        wsCols[index].width = wsCols[index].width === 0 ? 10 : wsCols[index].width * 1.5;

      return wsCols
    },

    exportToExcel: _.debounce(async function() {
      const XLSX = require("xlsx-js-style");

      this.isXlsExporting = true;

      await sleep(1);

      try {
        var st_dt_str = moment(moment().add(-2, 'month').toDate()).format("YYYY-MM")
        var en_dt_str = moment(moment().add(-1, 'month').toDate()).format("YYYY-MM")

        const dataOrigin = 'NAVER';
        var category = 'Unknown';

        const catServResp = await CategoryService.getOneCategory(this.$store.getters.getSelectedCategory, source);

        if (catServResp.data.success)
          category = catServResp.data.data.title

        const period = st_dt_str + ' ~ ' + en_dt_str;

        var criteria = '상위';

        if (this.selectedCriteria != null && this.selectedCriteria.title.length > 0)
          criteria = this.selectedCriteria.title;

        const workbook = XLSX.utils.book_new()	// 엑셀 생성

        XLSX.utils.book_append_sheet(workbook, 
                                     this.newSheet4Intro(dataOrigin, category, criteria, period, 'CATEGORY TREND'), 
                                     '데이터 개요')         

        var strPrev1Month = moment(moment().add(-1, 'month').toDate()).format("YY년 MM월");
        var strPrev2Month = moment(moment().add(-2, 'month').toDate()).format("YY년 MM월");
        var columns = [ strPrev1Month, strPrev2Month, strPrev2Month + ' 대비 Gap', strPrev2Month + ' 대비 Gap %' ]

        var resFetchGroups = [...this.fetchGroups];

        if (this.total_row)
          resFetchGroups.splice(0, 0, this.total_row);

        XLSX.utils.book_append_sheet(workbook, 
                                     this.newSheet4Data(dataOrigin, category, criteria, period, columns, resFetchGroups), 
                                     '최근 검색량 및 변화량')

        var total_keyword_list = []
        columns = [ strPrev1Month, strPrev2Month, strPrev2Month + ' 대비 Gap', '브랜드' ]

        var sel_Major = this.selectedMajorClass != null ? this.selectedMajorClass.title : null; 
        var sel_Middle = this.selectedMiddleClass != null ? this.selectedMiddleClass : null; 

        if (sel_Middle == '중분류 없음')
          sel_Middle = '기타'
        
        for (let id = 0; id < 4; id++) {
          const response = await CisTrendKeywordService.getTrendKeywordDataBarExp({
            thisMonthStart : moment(moment().add(-1, 'month').toDate()).format("YYYY-MM"),
            lastMonthStart : moment(moment().add(-2, 'month').toDate()).format("YYYY-MM"),
            thisMonthEnd : moment(moment().add(-1, 'month').toDate()).format("YYYY-MM"),
            lastMonthEnd : moment(moment().add(-2, 'month').toDate()).format("YYYY-MM"),
            ctgSq : this.$store.getters.getSelectedCategory,
            criteria : this.selectedCriteria.id,
            gubun: this.selectedGubun,
            filter: id, // 0 - 상위, 1 - 상승, 2 - 하락, 3 - 신규 등장
            selMajor: sel_Major, 
            selMiddle: sel_Middle
          }, source);

          if (response && response.status === 200) {
            var topRangKeywords = [];

            for(const item of response.data.data) {
              topRangKeywords.push({
                keyword: item.keyword,
                prev1Freq: item.thisFreq,
                prev2Freq: item.thisFreq - item.diffFreq,
                diff: item.diffFreq,
                brand: item.brand
              });  

              if (id == 0)
                total_keyword_list.push(item.keyword)
            }

            let filter = '';          
            switch(id) {
              case 0: filter = '상위'; break;
              case 1: filter = '상승'; break;
              case 2: filter = '하락'; break;
              case 3: filter = '신규 등장'; break;
            }

            XLSX.utils.book_append_sheet(workbook, 
                                         this.newSheet4TopRankKeywords(dataOrigin, category, criteria, period, this.selectedGubun, filter, columns, topRangKeywords), 
                                         (filter == '상위' ? '검색어' : filter) + ' 상위 키워드')
          }
        }

        var prev_month_dt = moment().add(-1, 'month').format("YYYY-MM")

        var en_dt = moment().add(-2, 'day').format("YYYY-MM-DD")
        var st_dt = moment(prev_month_dt).startOf('month').format("YYYY-MM-DD")

        var sel_Major = this.selectedMajorClass != null ? this.selectedMajorClass.title : null; 
        var sel_Middle = this.selectedMiddleClass != null ? this.selectedMiddleClass : null; 

        if (sel_Middle == '중분류 없음')
          sel_Middle = '기타'
       
        const response = await CisTrendKeywordService.getLatestMonthSearchVolumeExp({ 
          st_dt: st_dt, 
          en_dt: en_dt, 
          filterKeywords: total_keyword_list, 
          ctgSq : this.$store.getters.getSelectedCategory,
          selMajor: sel_Major, 
          selMiddle: sel_Middle
        }, source);     

        if (response && response.status === 200) {
          var topRangKeywordsTrk = [];

          for(const item of response.data.data) {
            topRangKeywordsTrk.push({
                keyword: item.keyword,
                freq: item.freq.split(',')
            })
          }
        }

        XLSX.utils.book_append_sheet(workbook, 
                                     this.newSheet4TopRankKeywordsTracking(dataOrigin, category, criteria, period, this.selectedGubun, this.lineChartCategories, topRangKeywordsTrk), 
                                     '검색량 상위 키워드 트래킹')

        XLSX.writeFile(workbook, 'category_trend_' + this.getToday() + '.xlsx')	// 엑셀 다운로드

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Excel export complete!!",
            icon: "EditIcon",
            variant: "success",
          },
        });
      }
      catch (err) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Excel export fail!!",
            icon: "AlertCircleIcon",
            variant: "warning",
          },
        });
      }

      this.isXlsExporting = false;
    }, 100),

    abort(isReset, message) {
      // cancel the request
      source.cancel(message);

      if (isReset)
        source = cancelToken.source();
    },

    async setMajorClasses() {
      console.log('---------- setMajorClasses ----------')

      this.majorClassList = [];
      this.selectedMajorClass = null;

      // 카테고리 정보가 설정되지 않은 경우 리턴
      if (sel_category == '9999' && this.$store.getters.getSelectedCategory == '9999') 
        return;

      sel_category = this.$store.getters.getSelectedCategory;

      const majorClasses = await CisTrendKeywordService.getmajorclasslist({ctgSq: this.$store.getters.getSelectedCategory}, source);

      if (majorClasses.data.success) {
        console.log('---------- Major Classes list ----------')
        console.log(majorClasses.data.data)

        this.majorClassList = majorClasses.data.data;        
      }
    },

    async setMiddleClasses() {
      console.log('---------- setMiddleClasses ----------')

      this.middleClassList = [];
      this.selectedMiddleClass = null;

      // 카테고리 정보가 설정되지 않은 경우 리턴
      if (sel_category == '9999' && this.$store.getters.getSelectedCategory == '9999') 
        return;

      sel_category = this.$store.getters.getSelectedCategory;

      var st_dt_str = moment(moment().add(-2, 'month').toDate()).format("YYYY-MM")
      var en_dt_str = moment(moment().add(-1, 'month').toDate()).format("YYYY-MM")

      const middleClasses = await CisTrendKeywordService.getmiddleclasslist({
        st_dt: st_dt_str,
        en_dt: en_dt_str,
        ctgSq: this.$store.getters.getSelectedCategory, 
        selMajor: this.selectedMajorClass.title
      }, source);

      if (middleClasses.data.success) {
        console.log('---------- Middle Classes list ----------')
        console.log(middleClasses.data.data)

        this.middleClassList = middleClasses.data.data; 

        var _idx = this.middleClassList.findIndex((element) => element == "기타");

        if (_idx >= 0) {
          this.middleClassList = this.middleClassList.with(_idx, "중분류 없음")
          this.middleClassList.sort()
        }
      }
    },

    runAnalysis() {
      if(this.$store.getters.getSelectedCategory != '9999'){
        this.selectedGubun = 'TOTAL'
        this.loadDataTable();
        this.loadDataBar()
      }
    }
  },
  mounted(){
    console.log('----- mounted -----')

    setTimeout(() => {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }, 200);

    if(this.$store.getters.getSelectedCategory != '9999')
    {
      this.loadDataTable();
      this.loadDataBar();
      this.setMajorClasses();
    }
  },

  destroyed() {
    console.log('----- destroyed -----')
    
    this.abort(false, 'destoryed')
  },

  created() {
    console.log('----- create -----')

    this.abort(true, 'created')

    this.$store.dispatch('callCISMenu', { cisMenu: 'trendkeyword' })
    
    this.selectedCriteria = this.criteria[0];
    this.selectedDisplayValue = this.displayValue[0];
    this.selectedFilterValue = this.filterValue[0];

    this.lineChartData = [];
    this.lineChartCategories = [];    
  },
  // setup(props) {
  //   const {
  //       fetchGroups,
  //       tableColumns,
  //       sortBy,
  //       isSortDirDesc,
  //       refTrendKeywordTable,
  //       reFetchData,
  //   } = trendKeywordTable(props);

  //   return {
  //       fetchGroups,
  //       tableColumns,
  //       sortBy,
  //       isSortDirDesc,
  //       refTrendKeywordTable,
  //       reFetchData,
  //   };
  // },
};

</script>

<style lang="scss">
// @import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/base/bootstrap-extended/_variables.scss";

// .overview .card-body {
//   padding: 1rem;
//   padding-bottom: 0;
// }

// .ver-mid {
//   display: flex;
//   align-items: center;
//   min-height: 100%;
//   height: 100%;
// }

// .card.highlight {
//   box-shadow: 0 0 10px rgba(0, 0, 0, 0.1) !important;
//   flex: 0 0 25%;
// }
// .card.highlight .card-body {
//   padding: 1rem;
// }
// .highlight-white {
//   border-top: #fff 4px solid;
// }
// .highlight-blue {
//   border-top: #3360d0 4px solid;
// }
// .highlight-green {
//   border-top: #38de92 4px solid;
// }
// .highlight-yellow {
//   border-top: #ded338 4px solid;
// }
// .icon-red {
//   color: red;
// }
// .icon-green {
//   color: green;
// }
// .flat-picker {
//   width: 263px;
// }

#trendkeywordBarCol .apexcharts-canvas .apexcharts-text, #trendkeywordBarCol .apexcharts-canvas .apexcharts-tooltip-text, #trendkeywordBarCol .apexcharts-canvas .apexcharts-datalabel-label, #trendkeywordBarCol .apexcharts-canvas .apexcharts-datalabel {
    font-family: "NanumBarunGothic", Arial, sans-serif !important;
    font-weight: bold;
    filter: none;
}

#trendkeywordBarCol .graphic-container {
  position: relative;
  min-height: 45rem;
  max-height: 45rem;
  overflow-y: auto;
  overflow-x: hidden;
}

#trendkeywordLineCol .graphic-container {
  padding-right: 0.75rem;
}

#trendkeywordLineCol .graphic-container .apexcharts-svg {
  overflow: visible;
}

.additional-info{
  width: 100%;
  position:absolute;
  list-style:none;
  z-index: 10;
  margin-left: -1%;
  pointer-events: none;
}
.additional-info li{
  width: 100%;
  margin-top: 1.0rem;
  margin-bottom: 1.545rem;
  margin-left: -1%;
  text-align: right;
  pointer-events: none;
}

.mb-1 .sticky-top{
  align-self: flex-start;
}

.tooltip-inner {
  color: #333;
  background: #fff;
  border: 1px solid #F2F2F2;
  font-family: "NanumBarunGothic", Arial, sans-serif !important;
  filter: none;
  box-shadow: 1px 1px 1px #F2F2F2;
  font-weight: bold;
}

/* Hide default icon */
.tkTable .table.b-table > thead > tr > th,
.tkTable .table.b-table > tfoot > tr > td {
  background-image: none !important;
  vertical-align: middle !important;
  padding: 0.75rem 0.5rem;
}

.tkTable .table.b-table > thead > tr > th,
.tkTable .table.b-table > tbody > tr > th,
.tkTable .table.b-table > tbody > tr > td {
  padding: 0.75rem 0.25rem !important;
}

.tkTable .table-font-size {
  font-size: 12px;
  font-weight: 600;
}

.tkTable .b-table-top-row {
  background-color: #1951dc25;
}

.table-nonbranded > th, .table-nonbranded > td {
  background-color: #bfbfbfa0;
}

.dsp-opt-btn {
  height: 28px; 
  width: 100px; 
  padding: 0.4rem 0.2rem; 
  margin: 2px; 
  border-radius: 0.38rem;
  background-color: #4E86FF !important; 
  border-color: #4E86FF !important;
}

.criteria .vs__dropdown-menu,
.major-class .vs__dropdown-menu,
.middle-class .vs__dropdown-menu
{
  padding: 0px 0px 0px 0px;
}

.criteria .vs__dropdown-toggle,
.major-class .vs__dropdown-toggle,
.middle-class .vs__dropdown-toggle 
{
  border: 2px solid #d8d6de;
}

.criteria .vs__search,
.major-class .vs__search,
.middle-class .vs__search,
.criteria .vs__selected,
.major-class .vs__selected,
.middle-class .vs__selected 
{
  height: 20px;
  margin-top: 4px !important;
}

</style>
